
// for refresh token
import axios from "axios";
import LoginUtil from "@/login/LoginUtil";
import urlUtil from "@/utils/urlUtil";
import { installResponseInterceptor } from "./sessionAuth";

Window.refreshingToken = false;

const request = axios.create()

// timeout
request.defaults.timeout = 1000 * 60 * 10; // 10 minutes

request.defaults.baseURL = urlUtil.getBaseUrl();


request.interceptors.request.use(async function (config) {
    // Do something before request is sent
    const url = config.url
    console.log(url.url)
    let token = await LoginUtil.getAccessTokenAsync()
    if(token &&
        (config.url !== undefined && !config.url.includes('authenticate') && !config.url.includes('bio-auth') && !config.url.includes('refresh-token'))){
        config.headers.common['Authorization'] = `Bearer ${token}`
        config.withCredentials=true
    }

    config.timeout = 10 * 60 * 1000; // 10 mins

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


// response interceptor: refresh on 401, otherwise end the session.
// See src/shared/apis/sessionAuth.js
installResponseInterceptor(request);

export default request

export {
    request
}
